import { render, staticRenderFns } from "./ProgramsInProgress.vue?vue&type=template&id=f7dfb872&scoped=true&"
import script from "./ProgramsInProgress.vue?vue&type=script&lang=ts&"
export * from "./ProgramsInProgress.vue?vue&type=script&lang=ts&"
import style0 from "./ProgramsInProgress.vue?vue&type=style&index=0&id=f7dfb872&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7dfb872",
  null
  
)

export default component.exports